import { callGlobalFunction, getGlobalArray } from "./utils.js";

export const ordersFeature = {
  get collection() {
    return getGlobalArray("orders");
  },
  renderClient() {
    return callGlobalFunction("renderClientOrders");
  },
  renderProvider() {
    return callGlobalFunction("renderProviderOrders");
  },
  renderAdmin() {
    return callGlobalFunction("renderAdminOrders");
  },
  loadMoreClient() {
    return callGlobalFunction("loadMoreClientOrders");
  },
  loadMoreProvider() {
    return callGlobalFunction("loadMoreProviderOrders");
  },
  loadMoreAdmin() {
    return callGlobalFunction("loadMoreAdminOrders");
  }
};
